enum AggregationOperation {
  COUNT = 'Count',
  MIN = 'Min',
  MAX = 'Max',
  SUM = 'Sum',
  ABS_SUM = 'AbsSum',
  VAR = 'Var',
  AVG = 'Avg',
  MEDIAN = 'Median',
  STD = 'Std',
  FIRST = 'First',
  LAST = 'Last',
  SKIP = 'Skip',
  COUNT_DISTINCT = 'CountDistinct',
  DISTINCT = 'Distinct',
  UNIQUE = 'Unique',
}

export default AggregationOperation;
